export type GenderValues = 'MALE' | 'FEMALE' | 'NOT_SPECIFIED';

enum GENDERS {
  MALE = 'Homme',
  FEMALE = 'Femme',
  NOT_SPECIFIED = 'Non précisé',
}
export default GENDERS;
